  import axios from "axios";
  import React, { useEffect, useState } from "react";
  import { useParams } from "react-router-dom";
  import { server } from "../server";

  const UserActivationPage = () => {
    const { activation_token } = useParams();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      if (activation_token) {
        const sendRequest = async () => {
          try {
            const res = await axios.get(`${server}/user/activate-account/${activation_token}`);
            console.log(res);
            setLoading(false);
          } catch (err) { 
            console.error(err.response.data); 
            setError(err.response.data.message || "An error occurred");
            setLoading(false);
          }
        };
        sendRequest();
      }
    }, [activation_token]);

    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <p>Your account has been created successfully!</p>
        )}
      </div>
    );
  };

  export default UserActivationPage;
